import retrospect from '@/views/page/drug/retrospect/route'
const drugRoutes = [
  {
    path: 'drug-send',
    name: 'drug-send',
    meta: {
      title: '发配药',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/drug/drug-send.vue'], resolve)
  },
  {
    path: 'drug-detail',
    name: 'drug-detail',
    meta: {
      title: '配药详情',
      requiresAuth: true,
      nav: {
        title: '发药',
        path: '/default/drug-send',
        children: null
      }
    },
    component: resolve => require(['../views/page/drug/drug-detail.vue'], resolve)
  },
  {
    path: 'drug-assembly',
    name: 'drug-assembly',
    meta: {
      title: '配药',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/drug/drug-assembly.vue'], resolve)
  },
  {
    path: 'drug-cancle',
    name: 'drug-cancle',
    meta: {
      title: '退药',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/drug/drug-cancle.vue'], resolve)
  },
  {
    path: 'drug-task',
    name: 'drug-task',
    meta: {
      title: '任务',
      requiresAuth: true,
      nav: false
    },
    component: resolve => require(['../views/page/drug/drug-task.vue'], resolve)
  },
  {
    path: 'drug-store',
    name: 'drug-store',
    meta: {
      title: '药库药品出入库',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/drug/drug-store.vue'], resolve)
  },
  {
    path: 'drug-transfer',
    name: 'drug-transfer',
    meta: {
      title: '药房调拨',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/drug/drug-transfer.vue'], resolve)
  },
  {
    path: 'drug-runtime-store',
    name: 'drug-runtime-store',
    meta: {
      title: '药房库存',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/drug/drug-runtime-store.vue'], resolve)
  },
  {
    path: 'drug-send-check',
    name: 'drug-send-check',
    meta: {
      title: '发药查询',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/drug/drug-send-check.vue'], resolve)
  },
  {
    path: 'drug-cancle-check',
    name: 'drug-cancle-check',
    meta: {
      title: '退药查询',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/drug/drug-cancle-check.vue'], resolve)
  },
  {
    path: 'drug-dispensing',
    name: 'drug-dispensing',
    meta: {
      title: '摆药申请单',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/drug/drug-dispensing.vue'], resolve)
  },
  {
    path: 'drug-dispensing-detail',
    name: 'drug-dispensing-detail',
    meta: {
      title: '摆药申请明细',
      requiresAuth: true,
      nav: {
        title: '摆药申请单',
        path: 'drug-dispensing',
        children: null
      }
    },
    component: resolve => require(['../views/page/drug/drug-dispensing-detail.vue'], resolve)
  },
  {
    path: 'drug-refund-management',
    name: 'drug-refund-management',
    meta: {
      title: '退费查询',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/drug/refund-management.vue'], resolve)
  },
  {
    path: 'medical-statistics',
    name: 'medical-statistics',
    meta: {
      title: '住院用药统计',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/drug/medical-statistics.vue'], resolve)
  },
  {
    path: 'medical-statistics-fee',
    name: 'medical-statistics-fee',
    meta: {
      title: '科室费用统计',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/drug/medical-statistics-fee.vue'], resolve)
  },
  {
    path: 'medical-statistics-patient',
    name: 'medical-statistics-patient',
    meta: {
      title: '科室费用统计',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/drug/medical-statistics-patient.vue'], resolve)
  },
  {
    path: 'drug-allot',
    name: 'drug-allot',
    meta: {
      title: '药品耗材调拨',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/drug/drug-allot.vue'], resolve)
  },
  ...retrospect
]
export default drugRoutes
